import { Link } from 'react-router-dom';
import { ArrowLeft, Shield } from 'lucide-react';

export function PrivacyPage() {
  return (
    <div className="bg-white min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-3xl mx-auto">
        <Link to="/" className="inline-flex items-center text-slate-500 hover:text-blue-600 mb-8 transition-colors">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Volver al inicio
        </Link>

        <div className="flex items-center gap-3 mb-6">
          <div className="p-3 bg-green-50 rounded-xl">
            <Shield className="w-8 h-8 text-green-600" />
          </div>
          <h1 className="text-3xl font-bold text-slate-900">Política de Privacidad</h1>
        </div>

        <div className="prose prose-slate max-w-none text-slate-600">
          <p className="lead text-lg text-slate-700">
            En EncuentraTrastero nos tomamos muy en serio la privacidad de tus datos. Esta política explica cómo recopilamos y tratamos tu información.
          </p>

          <h3>1. Datos que recopilamos</h3>
          <p>
            Para prestar nuestros servicios, podemos recopilar los siguientes datos:
          </p>
          <ul>
            <li>Datos de contacto: Nombre, email y teléfono (cuando publicas un anuncio o te registras).</li>
            <li>Datos del anuncio: Dirección, características y fotos del trastero.</li>
            <li>Datos técnicos: Dirección IP y cookies para mejorar la navegación.</li>
          </ul>

          <h3>2. Finalidad del tratamiento</h3>
          <p>
            Utilizamos tus datos exclusivamente para:
          </p>
          <ul>
            <li>Gestionar tu cuenta y tus anuncios.</li>
            <li>Facilitar el contacto entre interesados y propietarios.</li>
            <li>Enviarte notificaciones importantes sobre el servicio (ej. aprobación de anuncios).</li>
          </ul>

          <h3>3. Compartición de datos</h3>
          <p>
            No vendemos tus datos a terceros. Solo compartimos tu información de contacto (nombre, teléfono, email) con otros usuarios cuando tú lo autorizas explícitamente (por ejemplo, al publicar un anuncio para que te contacten).
          </p>

          <h3>4. Tus derechos</h3>
          <p>
            Tienes derecho a acceder, rectificar o eliminar tus datos en cualquier momento. Puedes hacerlo desde tu perfil de usuario o contactando con nosotros en info@encuentratrastero.com.
          </p>
        </div>
      </div>
    </div>
  );
}
